import {UseFormReturn} from 'react-hook-form';

import {VehicleSelectionFormBinding} from '../../../types/VehicleSelectionFormBinding';
import {PromoPhotosFormType} from '../types/PromoPhotosFormType';

export const getPromoPhotoVehicleSelectionBinding = (
  formApi: UseFormReturn<PromoPhotosFormType>
): VehicleSelectionFormBinding<PromoPhotosFormType> => ({
  getListFieldName: (field) => `filter.${field}`,
  getNumberFieldName: (field) => `filter.${field}`,
  getTextFieldName: (field) => `filter.${field}`,
  setListFieldValue: (field, value, options) => formApi.setValue(`filter.${field}`, value, options),
  setTextFieldValue: (field, value, options) => formApi.setValue(`filter.${field}`, value, options),
});
